import React from 'react';

// Six Morsebridge services then three Diligentsia ones — the brand label on each card is what
// tells the reader which side of the partnership delivers it.
const SERVICES = [
    { brand: 'mb', title: 'Deal sourcing', body: 'Proprietary origination and target identification, verified across multiple sources.' },
    { brand: 'mb', title: 'CIM and SIM screening', body: 'Fast first-view screening of inbound opportunities with a clear go or pass read.' },
    { brand: 'mb', title: 'Commercial due diligence', body: 'Market, customer and competitive assessment to test the investment thesis.' },
    { brand: 'mb', title: 'Financial due diligence and QoE', body: 'Quality of earnings, addback validation and an adjusted EBITDA you can defend.' },
    { brand: 'mb', title: 'Management due diligence', body: 'Owner dependence, team capability and key-person risk assessment.' },
    { brand: 'mb', title: 'IC memo preparation', body: 'Decision-ready investment committee memos built from the diligence record.' },
    { brand: 'dg', title: 'Investment readiness and diligence packs', body: 'Diligence-pack creation and reverse vendor diligence, financial and technical.' },
    { brand: 'dg', title: 'Portfolio monitoring', body: 'Post-investment reporting roll-ups and performance monitoring across the portfolio.' },
    { brand: 'dg', title: 'Exit preparation', body: 'Exit-readiness assessment and vendor diligence, viewed the way a buyer will.' },
];

const ICONS = {
    mb: require('../../../../images/landing-pages/PE/morsebridge-icon-white.png'),
    dg: require('../../../../images/landing-pages/PE/diligentsia-icon.png'),
};
const LABELS = { mb: 'MORSEBRIDGE', dg: 'DILIGENTSIA' };

const PECombinedServices = () => (
    <section className="lp-pe-services">
        <div className="lp-pe-wrap">
            <div className="lp-pe-services-head">
                <h2 className="lp-pe-h2" data-lp-reveal>Combined Services</h2>
                <p data-lp-reveal data-lp-delay="80">Each engagement is scoped to your firm. We build the tools and workflows into your stack, configured to how you source, diligence and monitor.</p>
            </div>
            <div className="lp-pe-services-grid">
                {SERVICES.map((s, i) => (
                    <div className="lp-pe-service" key={s.title} data-lp-reveal data-lp-delay={(i % 3) * 80}>
                        <img className="lp-pe-service-icon" src={ICONS[s.brand]} alt="" />
                        <span className={`w100 lp-pe-service-brand is-${s.brand}`}>{LABELS[s.brand]}</span>
                        <h3 className='w100'>{s.title}</h3>
                        <p>{s.body}</p>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default PECombinedServices;
